import React from 'react';
import styled from 'astroturf/react';
import { Placement } from '@floating-ui/react';
import { Menu } from 'js/design_system/Menu';
import { MenuItem as MenuItemBase } from 'js/design_system/MenuItem';
import { MultiDotMore } from 'js/social/shared/Icons';
import { Button } from 'js/social/shared/design_system/Button';
import { Props as ImpressionProps } from 'js/utils/impressions/ImpressionWatcher';
import ImpressionWatcher from 'js/utils/impressions/ImpressionWatcher';

const MenuItemContainer = styled(MenuItemBase)`
  @import 'stylesheets/design_system/_breakpoint.scss';

  display: flex;
  gap: 6px;
  color: $ds-gray-dark;
  padding: 12px 16px;
  white-space: nowrap;
  min-width: 240px;

  @include for-tablet-up {
    min-width: 320px;
  }
`;

const MenuItemInfo = styled.div`
  flex-grow: 1;
`;

const MenuItemText = styled.div`
  @import 'stylesheets/design_system/_breakpoint.scss';
  @import 'stylesheets/design_system/font';
  @include body__medium-medium;
  @import 'stylesheets/design_system/_util.scss';
  @include text-ellipsis;
  width: 182px;

  @include for-tablet-up {
    width: 262px;
  }
`;

const MenuItemSubtext = styled.div`
  @import 'stylesheets/design_system/font';
  @import 'stylesheets/design_system/_util.scss';
  @include text-ellipsis;
  @include sans-serif;
  font-size: 12px;
  line-height: 16px;
`;

type MenuItemProps = {
  showItem: boolean;
  itemIcon?: JSX.Element;
  itemText: string;
  itemSubtext?: string;
  onClick: () => void;
  impressionProps?: ImpressionProps;
};

type MenuProps = {
  placement: Placement;
  menuItems: MenuItemProps[];
  buttonClassName?: string;
};

export const MenuItem: React.FunctionComponent<MenuItemProps> = ({
  showItem,
  itemIcon,
  itemText,
  itemSubtext,
  onClick,
}) =>
  showItem ? (
    <MenuItemContainer onClick={onClick}>
      {itemIcon}
      <MenuItemInfo>
        <MenuItemText>{itemText}</MenuItemText>
        <MenuItemSubtext>{itemSubtext}</MenuItemSubtext>
      </MenuItemInfo>
    </MenuItemContainer>
  ) : null;

export const SocialActionsMenu: React.FunctionComponent<MenuProps> = ({
  placement,
  menuItems,
  buttonClassName,
}) => {
  const items = menuItems
    .map((menuItem) =>
      menuItem.impressionProps && menuItem.showItem ? (
        <ImpressionWatcher
          key={menuItem.itemText}
          stopPropagation={false}
          {...menuItem.impressionProps}
        >
          <MenuItem {...menuItem} />
        </ImpressionWatcher>
      ) : (
        <MenuItem key={menuItem.itemText} {...menuItem} />
      ),
    )
    .filter((element: any) => !!element);

  if (items.length <= 0) return null;

  return (
    <div>
      <Menu placement={placement} render={() => <>{items}</>}>
        <Button
          variant="text-gray"
          icon={<MultiDotMore />}
          className={buttonClassName}
        />
      </Menu>
    </div>
  );
};
